// pruebas-expediente.component.ts
import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { MatMenuModule } from '@angular/material/menu';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TiposPruebasExpediente, AccionesDialog } from '@models/base/identificadores.model';
import { MatSidenavModule } from '@angular/material/sidenav';
import { ButtonNewComponent } from '@component/button-new/button-new.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { DialogParams } from '@interfaces/dialogParam.interface.model';
import { SnackBarService } from '@services/snackBar/snack-bar-service.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { BreakpointObserver } from '@angular/cdk/layout';
import { ListadoPruebaTestimonialComponent } from '@views/pruebas/pruebaTestimonial/listado-prueba-testimonial/listado-prueba-testimonial.component';
import { DialogFormPruebaTestimonialComponent } from '@views/pruebas/pruebaTestimonial/form-prueba-testimonial/dialog-form-prueba-testimonial.component';
import { DialogFormPruebaInformativaComponent } from '@views/pruebas/pruebaInformativa/dialog-form-prueba-informativa/dialog-form-prueba-informativa.component';
import { ListadoPruebaInformativaComponent } from '@views/pruebas/pruebaInformativa/listado-prueba-informativa/listado-prueba-informativa.component';
import { ListadoPruebaConfesionalComponent } from '@views/pruebas/pruebaConfesional/listado-prueba-confesional/listado-prueba-confesional.component';
import { DialogFormPruebaConfesionalComponent } from '@views/pruebas/pruebaConfesional/dialog-form-prueba-confesional/dialog-form-prueba-confesional.component';
import { ListadoPericiaComponent } from '@views/pruebas/pericia/listado-pericia/listado-pericia.component';
import { DialogFormPericiaComponent } from '@views/pruebas/pericia/dialog-form-pericia/dialog-form-pericia.component';

@Component({
  selector: 'app-pruebas-expediente',
  standalone: true,
  imports: [
    CommonModule,
    MatCardModule,
    MatButtonModule,
    MatIconModule,
    MatMenuModule,
    MatTooltipModule,
    MatSidenavModule,
    ListadoPruebaInformativaComponent,
    ListadoPruebaTestimonialComponent,
    ListadoPruebaConfesionalComponent,
    ListadoPericiaComponent,
    ButtonNewComponent
  ],
  templateUrl: './pruebas-expediente.component.html',
  styleUrls: ['./pruebas-expediente.component.css']
})
export class PruebasExpedienteComponent implements OnInit {
  @Input() idExpediente!: number;

  // Estado del navegador - INICIALIZAR CORRECTAMENTE
  isNavCollapsed: boolean = false;

  // Tipos de pruebas
  tipoSeleccionado: TiposPruebasExpediente | null = null;
  pruebasExpediente: TiposPruebasExpediente | null = null;

  // Referencias a enums
  tiposPruebasExpediente = TiposPruebasExpediente;
  accionesDialog = AccionesDialog;

  navItems = [
    {
      icon: 'gavel',
      title: 'Pruebas Periciasles',
      subtitle: 'Peritajes técnicos, evaluaciones especializadas y dictámenes periciales',
      tipoPrueba: TiposPruebasExpediente.PruebaPericial
    },
    {
      icon: 'record_voice_over',
      title: 'Pruebas Testimoniales',
      subtitle: 'Declaraciones juradas, testimonios de testigos y audiencias',
      tipoPrueba: TiposPruebasExpediente.PruebaTestimonios
    },
    {
      icon: 'record_voice_over',
      title: 'Pruebas Confesionales',
      subtitle: 'Declaraciones bajo juramento, confesiones y absolución de posiciones',
      tipoPrueba: TiposPruebasExpediente.PruebaConfesional
    },
    {
      icon: 'info',
      title: 'Pruebas Informativas',
      subtitle: 'Informes oficiales, oficios y solicitudes de información institucional',
      tipoPrueba: TiposPruebasExpediente.PruebaInformativa
    }
  ];

  constructor(
    private snackBar: SnackBarService,
    private spinner: NgxSpinnerService,
    private breakpointObserver: BreakpointObserver,
    private dialog: MatDialog,
  ) {

  }

  ngOnInit(): void {
    console.log('Component initialized - Nav collapsed:', this.isNavCollapsed);
  }

  onCategoriaSeleccionada(tipoPrueba: TiposPruebasExpediente): void {
    console.log('Categoría seleccionada:', tipoPrueba);
    this.tipoSeleccionado = tipoPrueba;
    this.pruebasExpediente = tipoPrueba;
  }

  // MÉTODO SIMPLE PARA TOGGLE
  toggleNav(): void {
    this.isNavCollapsed = !this.isNavCollapsed;
    console.log('Toggle nav - New state:', this.isNavCollapsed);
  }


  onMenuToggled(isCollapsed: boolean): void {
    this.isNavCollapsed = isCollapsed;
    console.log('Menu toggled externally:', this.isNavCollapsed);
  }

  forzarSeleccion(tipo: TiposPruebasExpediente): void {
    this.tipoSeleccionado = tipo;
    this.pruebasExpediente = tipo;
  }

  openDialog<T>(params: DialogParams<T>) {
    const { accion, entidad, modulo } = params;

    const data = {
      ...entidad,
      accion,
      modulo,
      idExpediente: this.idExpediente
    };

    const dialogConfig = new MatDialogConfig();
    dialogConfig.autoFocus = false
    dialogConfig.data = data
    dialogConfig.height = "80%"
    var formulario: any
    switch (modulo) {
      case "pruebaInformativa":
        dialogConfig.width = "80%"
        formulario = DialogFormPruebaInformativaComponent
        break;
      case "pruebaTestimonial":
        dialogConfig.width = "80%"
        formulario = DialogFormPruebaTestimonialComponent
        break;
      case "pruebaConfesional":
        dialogConfig.width = "80%"
        formulario = DialogFormPruebaConfesionalComponent
        break;
      case "pruebaPericial":
        dialogConfig.width = "80%"
        formulario = DialogFormPericiaComponent
        break;

      default:
        dialogConfig.width = "80%"
        break;
    }

    const dialogRef = this.dialog.open(formulario, dialogConfig);

    dialogRef.afterClosed().subscribe(result => {
      if (result?.event === AccionesDialog.Agregar && result?.modulo) {
      }
    });
  }
}
